import "./App.css";
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/Home";
import Faq from "./pages/Faq/Faq";
import AboutUs from "./pages/AboutUs/AboutUs";
import Layout from "./Componants/Layout/Layout";
import Privacy from "./pages/Privacy/Privacy";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import aboutUsPage from "./Utilities/Redux/Services/AboutUs.Services";
import privacyPolicy from "./Utilities/Redux/Services/PrivacyPolicy.Services";
import FAQ from "./Utilities/Redux/Services/FAQ.Services";
import DeleteAccountPolicy from "./pages/DeleteAccountPolicy/DeleteAccountPolicy";

function App() {
const dispatch = useDispatch()
useEffect(() => {
  dispatch(aboutUsPage({slug:"about-us"}));
  dispatch(privacyPolicy({slug:"privacy-policy"}))
  dispatch(FAQ({slug:"faq"}))
 },[])
  return (
    <div className="App">
      <Routes>
      <Route path="/" element={<Home />} />
        <Route path="/" element={<Layout />}>
          {/* <Route path="/" element={<Home />} /> */}
          {/* <Route path="/faq" element={<Faq />} /> */}
          <Route path="/faq" element={<Faq />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/delete-account-policy" element={<DeleteAccountPolicy />} />
        </Route>
    
      </Routes>
    </div>
  );
}

export default App;
